import React, { useEffect } from "react";
import ReportsHeader from "../../../components/generic/ReportsHeader/ReportsHeader";
import "../../../stylesheets/components/Reports/PnlViewTransactionReport/PnlViewTransactionReport.scss";
import PnlSummary from "./PnlSummary";
import PnlReportsTable from "./PnlReportsTable";
import ConfirmationPopup from "../../generic/ConfirmationPopup/ConfirmationPopup";
import EditTransactionPopup from "./PnlEditScreen/EditTransactionPopup";
import DeviceContext from "../../../utils/indentifyDevice";
import Drawer from "react-bottom-drawer";
import ConfirmationPopupMob from "../../../components/generic/ConfirmationPopup/ConfirmationPopupMob";
import EditTransactionPopupMob from "./PnlEditScreen/EditTransactionPopupMob";
import di from "../PNLReports/di/servicelocator";
import { useSelector } from "react-redux";
import { useQuery } from "../../../utils/urlHelper";
import { TransactionType, } from "@domains/aggregates/interfaces/Reports/iPNLTransactionReport";
import moment from "moment";
import SmallcasePopup from "../HoldingReports/SMCaseLoadPopup/SmcasePopupLoader";
import SmcasePopupSuccess from "../HoldingReports/SMCaseLoadPopup/SmcasePopupSuccess";
import SmcasePopupFail from "../HoldingReports/SMCaseLoadPopup/SmcasePopupFail";
import SmcasePopupLoaderMob from "../HoldingReports/SMCaseLoadPopup/SmcasePopupLoaderMob";
import SmcasePopupSuccessMob from "../HoldingReports/SMCaseLoadPopup/SmcasePopupSuccessMob";
import SmcasePopupFailMob from "../HoldingReports/SMCaseLoadPopup/SmcasePopupFailMob";
import { createSearchParams, useLocation, useNavigate, useParams, } from "react-router-dom";
import { accountDetails } from "@di";
import { assetTypeMappingObj, TabMapping, } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import { getDateInFormat, getDay, previousDay, } from "@domains/utils/reportDates";
import { ReportName } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { holdingTabsAssetFilterValues, } from "../CommonComponent/constant";
import { getLoginSourceURL } from "@frameworks/web/utils/Navigate";
import { getQueryParameterName } from "../../../utils/urlHelper";
const PnlViewTransactionReport = () => {
    const transactionReportData = useQuery();
    const navigate = useNavigate();
    const location = useLocation();
    const { loginOrigin } = useParams();
    const accCode = window.atob(getQueryParameterName("accCode"));
    const locationState = location.state;
    const [summaryParamters, setSummaryParameters] = React.useState();
    const [initConfirmPopup, setInitConfirmPopup] = React.useState(false);
    const [transactionPopup, setTransactionPopup] = React.useState(false);
    const [showLoader, setShowLoader] = React.useState(false);
    const [downloadSuccess, setDownloadSuccess] = React.useState(false);
    const [downloadFail, setDownloadFail] = React.useState(false);
    const [showTableDropdown, setshowTableDropdown] = React.useState(false);
    const [editRow, setEditRow] = React.useState(false);
    const [editableRecord, setEditableRecord] = React.useState();
    const [reviewChangePopup, setReviewChangePopup] = React.useState(false);
    const [initConfirmBackDrop, setInitConfirmBackDrop] = React.useState(false);
    const [reviewBackDrop, setReviewBackDrop] = React.useState(false);
    const [pnLEditSplitRequests, setPnLEditSplitRequests] = React.useState([]);
    const [shimmer, setShimmer] = React.useState(true);
    const [editTransactionBackDrop, setEditTransactionBackDrop] = React.useState(false);
    const pnlSelectedTradeDetails = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.pnlReport) === null || _a === void 0 ? void 0 : _a.selectedStockDetails; });
    const { data: pnlTableData, txnStatus: pnlEditError, showTransactionShimmer: showShimmer, pnlOriginalTxns: pnlOriginalTxns, orgTxnLoader: orgTxnLoader, orgTxnStatus: orgTxnStatus, } = useSelector((state) => state === null || state === void 0 ? void 0 : state.pnltranasactionReport);
    const holdingProdDropDown = useSelector((state) => state.holdingReport.prodDropDown);
    const productAssetCodeOfSelectedScrip = summaryParamters === null || summaryParamters === void 0 ? void 0 : summaryParamters.edelweissProductCode;
    React.useEffect(() => {
        if (di.pnlReport.viewTransactionClick) {
            di.pnlReport.viewTransactionClick = false;
            return;
        }
        if (pnlEditError && pnlEditError.isOpen !== null) {
            if (pnlEditError.isOpen) {
                if (DeviceContext().isDesktop) {
                    setShowLoader(false);
                    setDownloadSuccess(true);
                }
                else {
                    closeDrawerLoader();
                    openDrawerDownloadS();
                }
            }
            else {
                if (DeviceContext().isDesktop) {
                    setShowLoader(false);
                    setDownloadFail(true);
                }
                else {
                    closeDrawerLoader();
                    openDrawerFail();
                }
            }
        }
    }, [pnlEditError]);
    const setPNLSummaryParameters = () => {
        const summaryObj = Object.fromEntries(transactionReportData);
        setSummaryParameters(summaryObj);
    };
    useEffect(() => {
        if (pnlSelectedTradeDetails.tradeDetails)
            setSummaryParameters(pnlSelectedTradeDetails);
        else
            setPNLSummaryParameters();
    }, [pnlSelectedTradeDetails]);
    const initGoBack = () => {
        setInitConfirmPopup(false);
        setTransactionPopup(false);
    };
    const setUrl = () => {
        const assetTypeObj = Object.entries(assetTypeMappingObj);
        let appendAssetType = "";
        let tabRecord;
        if (Array.isArray(summaryParamters === null || summaryParamters === void 0 ? void 0 : summaryParamters.assetType)) {
            assetTypeObj.map((assetRecord) => {
                summaryParamters.assetType.map((x) => {
                    var _a;
                    if (x === ((_a = assetRecord[1]) === null || _a === void 0 ? void 0 : _a.assetType))
                        appendAssetType = appendAssetType + assetRecord[1].assetType + ",";
                });
            });
            appendAssetType.slice(0, -1);
            tabRecord = TabMapping[5];
        }
        else {
            for (let i = 0; i < assetTypeObj.length; i++) {
                if (assetTypeObj[i][1].assetType === summaryParamters.assetType) {
                    appendAssetType = assetTypeObj[i][1].assetType;
                    break;
                }
            }
            tabRecord = TabMapping.find((tabRecord) => {
                var _a, _b;
                if (((_a = tabRecord === null || tabRecord === void 0 ? void 0 : tabRecord.assetType) === null || _a === void 0 ? void 0 : _a.length) > 0)
                    return (_b = tabRecord === null || tabRecord === void 0 ? void 0 : tabRecord.assetType) === null || _b === void 0 ? void 0 : _b.find((assetType) => assetType === summaryParamters.assetType);
            });
        }
        // Build the URL parameters
        const urlParams = new URLSearchParams({
            reportName: "ProfitandLoss",
            tab: tabRecord.tabEventKey,
            assetType: (appendAssetType === null || appendAssetType === void 0 ? void 0 : appendAssetType.replace(/\s/g, "")) || "",
            fromDate: moment(summaryParamters.fromDate).format("yyyy-MM-DD"),
            toDate: moment(summaryParamters.toDate).format("yyyy-MM-DD"),
        });
        // Construct the full destination URL
        const baseUrl = ".." + getLoginSourceURL(loginOrigin);
        const destination = `${baseUrl}?${urlParams.toString()}`;
        // Navigate to the destination
        navigate(destination, {
            state: {
                replace: true,
                appendAssetType: appendAssetType,
            },
        });
    };
    const reviewGoBack = () => {
        setReviewChangePopup(false);
        setTransactionPopup(true);
    };
    const getPnlTable = () => {
        if (summaryParamters) {
            if (locationState && locationState.reportType === ReportName.HOLDINGS) {
                let payloadHoldingTxn = {
                    accountIds: (accCode === null || accCode === void 0 ? void 0 : accCode.length) > 0 ? accCode : "",
                    scripIdentifier: summaryParamters.tradeDetails
                        ? summaryParamters.tradeDetails.scripIdentifier
                        : summaryParamters.scripIdentifier,
                    date: getDateInFormat(previousDay, "YYYY-MM-DD"),
                };
                di.pnlTransactionReport.holdingTransactionDetails(payloadHoldingTxn);
            }
            else {
                const payload = {
                    fromDate: moment(summaryParamters.fromDate).format("yyyy-MM-DD"),
                    toDate: moment(summaryParamters.toDate).format("yyyy-MM-DD"),
                    assetType: summaryParamters.assetType,
                    scripIdentifier: summaryParamters.tradeDetails
                        ? summaryParamters.tradeDetails.scripIdentifier
                        : summaryParamters.scripIdentifier,
                    transactionType: summaryParamters.transactionType,
                    accountIds: (accCode === null || accCode === void 0 ? void 0 : accCode.length) > 0 ? accCode : "",
                };
                di.pnlTransactionReport.getPNLTransactionsReportData(payload);
            }
            if (summaryParamters.transactionType === TransactionType.REALISED)
                di.pnlTransactionReport.getRealisedUnderstandingSectionData();
            else if (summaryParamters.transactionType === TransactionType.UNREALISED)
                di.pnlTransactionReport.getUnrealisedUnderstandingSectionData();
        }
    };
    useEffect(() => {
        getPnlTable();
    }, [summaryParamters]);
    const sendSplitRecord = async () => {
        if (summaryParamters) {
            let tempData = pnLEditSplitRequests;
            if (pnLEditSplitRequests && pnLEditSplitRequests.length > 0) {
                tempData = pnLEditSplitRequests.map((editRecord) => {
                    editRecord.newDate =
                        moment(editRecord.newDate).format("yyyy-MM-DD") == "Invalid date"
                            ? moment(editRecord.newDate, "DD-MM-YY").format("yyyy-MM-DD")
                            : moment(editRecord.newDate).format("yyyy-MM-DD");
                    return editRecord;
                });
            }
            let payload = {
                accountId: await accountDetails.getAccountCode(),
                fromDate: moment(summaryParamters.fromDate).format("yyyy-MM-DD"),
                toDate: moment(summaryParamters.toDate).format("yyyy-MM-DD"),
                transactionType: summaryParamters.transactionType,
                scripIdentifier: editableRecord === null || editableRecord === void 0 ? void 0 : editableRecord.scripIdentifier,
                pnLEditSplitRequests: tempData,
            };
            if (summaryParamters.duration) {
                payload.duration = summaryParamters.duration;
            }
            di.pnlTransactionReport.sendEditSplitPNLTransactionData(payload);
        }
    };
    const callEditApiIntegration = () => {
        setShowLoader(true);
        sendSplitRecord();
    };
    const callEditApiIntegrationMob = () => {
        openDrawerLoader();
        sendSplitRecord();
    };
    const initConfirm = () => {
        setInitConfirmPopup(false);
        setInitConfirmBackDrop(false);
        setTransactionPopup(true);
    };
    const reviewConfirm = () => {
        setReviewChangePopup(false);
        setInitConfirmPopup(false);
        setTransactionPopup(false);
        if (DeviceContext().isDesktop)
            callEditApiIntegration();
        else
            callEditApiIntegrationMob();
        setInitConfirmBackDrop(false);
        setReviewBackDrop(false);
        setEditTransactionBackDrop(false);
    };
    const editGoBack = () => {
        setTransactionPopup(false);
        setInitConfirmPopup(true);
        setInitConfirmBackDrop(true);
        setEditTransactionBackDrop(false);
    };
    const editConfirmation = () => {
        setTransactionPopup(false);
        setReviewChangePopup(true);
    };
    const goBack = () => {
        var _a, _b;
        const qureyParmaObj = {
            isin: summaryParamters.tradeDetails
                ? summaryParamters.tradeDetails.quote.isin
                : summaryParamters.isin,
            scripName: summaryParamters.tradeDetails
                ? summaryParamters.tradeDetails.scripName
                : summaryParamters.scripName,
            companyName: summaryParamters.tradeDetails
                ? summaryParamters.tradeDetails.quote.description
                : summaryParamters.companyName,
            qty: summaryParamters.tradeDetails
                ? ((_a = summaryParamters.tradeDetails) === null || _a === void 0 ? void 0 : _a.isRealisedPnL)
                    ? summaryParamters.tradeDetails.realisedQuantity
                    : summaryParamters.tradeDetails.unrealisedBuyQuantity
                : summaryParamters.qty,
            ltp: summaryParamters.tradeDetails
                ? summaryParamters.tradeDetails.quote.lastTradedPrice
                : summaryParamters.ltp,
            scripIdentifier: summaryParamters.tradeDetails
                ? summaryParamters.tradeDetails.scripIdentifier
                : summaryParamters.scripIdentifier,
            fromDate: summaryParamters.tradeDetails
                ? summaryParamters.fromDate
                : summaryParamters.fromDate,
            endDate: summaryParamters.tradeDetails
                ? summaryParamters.toDate
                : summaryParamters.toDate,
            transactionType: summaryParamters.transactionType,
            assetType: summaryParamters.assetType,
            change: summaryParamters.tradeDetails
                ? (_b = summaryParamters.tradeDetails) === null || _b === void 0 ? void 0 : _b.quote.change
                : summaryParamters.change,
            changePercentage: summaryParamters.tradeDetails
                ? summaryParamters.tradeDetails.quote.changePercentage
                : summaryParamters.changePercentage,
        };
        navigate({
            pathname: "/view-pnl-transaction-report",
            search: `?${createSearchParams(qureyParmaObj)}`,
        }, {
            state: Object.assign({}, locationState),
        });
    };
    const goBackToHolding = () => {
        let searchPARAMS = !!holdingProdDropDown &&
            !holdingTabsAssetFilterValues.includes(holdingProdDropDown)
            ? createSearchParams({
                reportName: "Holding",
                activeHoldingTabName: locationState.activeHoldingTabName,
                edelweissProductCode: productAssetCodeOfSelectedScrip,
            })
            : createSearchParams({
                reportName: "Holding",
                activeHoldingTabName: locationState.activeHoldingTabName,
            });
        navigate({
            pathname: "/reports",
            search: searchPARAMS.toString(),
        });
    };
    const openDrawerInitConfirm = React.useCallback(() => setInitConfirmBackDrop(true), []);
    const closeDrawerInitConfirm = React.useCallback(() => setInitConfirmBackDrop(false), []);
    const closeDrawerReviewForm = React.useCallback(() => setReviewBackDrop(false), []);
    const closeDrawerTransaction = React.useCallback(() => setEditTransactionBackDrop(false), []);
    const openDrawerLoader = React.useCallback(() => setShowLoader(true), []);
    const openDrawerDownloadS = React.useCallback(() => setDownloadSuccess(true), []);
    const openDrawerFail = React.useCallback(() => setDownloadFail(true), []);
    const closeDrawerLoader = React.useCallback(() => setShowLoader(false), []);
    const closeDrawerDownloadS = React.useCallback(() => setDownloadSuccess(false), []);
    React.useEffect(() => {
        setShimmer(showShimmer);
    }, [showShimmer]);
    const closeDrawerFail = React.useCallback(() => setDownloadFail(false), []);
    return (React.createElement("div", null,
        React.createElement("section", { id: "pnl-view-transaction-report" },
            React.createElement("div", { className: "pnl-view-header-section" },
                React.createElement(ReportsHeader, { title: "Transaction Details", dateText: (summaryParamters === null || summaryParamters === void 0 ? void 0 : summaryParamters.toDate)
                        ? moment(summaryParamters === null || summaryParamters === void 0 ? void 0 : summaryParamters.toDate).format("DD-MMM-YY")
                        : "", timeString: "", redirectFunction: () => {
                        if ((locationState === null || locationState === void 0 ? void 0 : locationState.reportType) === ReportName.HOLDINGS)
                            goBackToHolding();
                        else
                            setUrl();
                    } })),
            React.createElement(PnlSummary, { mainCompShimmer: shimmer, pnlViewReportData: summaryParamters, transactionType: pnlTableData === null || pnlTableData === void 0 ? void 0 : pnlTableData.pnl }),
            pnlTableData && (React.createElement("div", null, (pnlTableData === null || pnlTableData === void 0 ? void 0 : pnlTableData.editableTransactionCount) > 0 && (React.createElement("div", { className: "pnl-editable-action" },
                React.createElement("div", { className: "checkbox-container" },
                    React.createElement("label", { className: "pnl-edit-checkbox" },
                        React.createElement("input", { type: "checkbox", name: "pnl-cta", onClick: () => setEditRow(!editRow) }),
                        React.createElement("span", { className: "teleport-switch-control-indicator" }),
                        React.createElement("span", { className: "edit-text" },
                            "Show",
                            " ",
                            pnlTableData.editableTransactionCount > 0
                                ? pnlTableData.editableTransactionCount
                                : 0,
                            " ",
                            "editable transactions"))))))),
            React.createElement(PnlReportsTable, { showEditableRows: editRow, mainCompShimmer: shimmer, setShimmer: setShimmer, pnlReportData: pnlTableData === null || pnlTableData === void 0 ? void 0 : pnlTableData.pnLTransactionDetails, setEditableRecord: setEditableRecord, setShowEditPopup: DeviceContext().isDesktop
                    ? setInitConfirmPopup
                    : openDrawerInitConfirm, productAssetCodeOfSelectedScrip: productAssetCodeOfSelectedScrip }),
            DeviceContext().isDesktop ? (React.createElement(React.Fragment, null,
                (showLoader || orgTxnLoader) && (React.createElement("div", { className: "modalBackground" },
                    React.createElement("div", { className: "modalContainer" },
                        React.createElement(SmallcasePopup, { Title: "Edit PNL Transaction", isDownload: false })))),
                downloadSuccess && (React.createElement("div", { className: "modalBackground" },
                    React.createElement("div", { className: "modalContainer" },
                        React.createElement(SmcasePopupSuccess, { setDownloadSuccess: setDownloadSuccess, isDownload: false, Title: "Edit PNL Transaction", closeDropdown: setshowTableDropdown, operation: null, pageName: "view transaction report", tabName: "", message: "Your request was successfully processed.<br/>" +
                                "Updated price will reflect in the P&L on " +
                                moment(getDay(1)).format("DD-MM-yyyy") +
                                ".", sendBack: true, goBack: goBack })))),
                (downloadFail || orgTxnStatus.isOpen) && (React.createElement("div", { className: "modalBackground" },
                    React.createElement("div", { className: "modalContainer" },
                        React.createElement(SmcasePopupFail, { isDownload: false, setDownloadFail: setDownloadFail, Title: "Edit PNL Transaction ", closeDropdown: setshowTableDropdown, operation: null, pageName: "view transaction report", sendBack: true, goBack: goBack })))),
                React.createElement(ConfirmationPopup, { popupClass: "", description: `You are only allowed to edit the details once. 
                                Are you sure you want to continue?`, popTitle: "Confirm Editing", show: initConfirmPopup, setShow: setInitConfirmPopup, btnFirstTitle: "No, Go back", btnSecTitle: "Yes, Confirm", goBackBtn: true, btnFirstCta: initGoBack, btnSecCta: initConfirm, showFooter: true }),
                React.createElement(ConfirmationPopup, { popupClass: "", description: `You are not allowed to edit the details more than once. 
              Are you sure you want to continue?`, popTitle: "Confirm Editing", show: reviewChangePopup, setShow: setReviewChangePopup, btnFirstTitle: "Review Changes", btnSecTitle: "Yes, Confirm", goBackBtn: false, btnFirstCta: reviewGoBack, btnSecCta: reviewConfirm, showFooter: true }),
                !orgTxnLoader && !orgTxnStatus.isOpen && (React.createElement(EditTransactionPopup, { popupClass: "", description: "You are not allowed to edit the details more than once.", popTitle: "Edit Transaction", show: transactionPopup, setShow: setTransactionPopup, goBackBtn: false, ConfirmBtnTitle: "Confirm", confirmBtnCta: editConfirmation, goBackCta: initGoBack, editableRecord: editableRecord, setPnLEditSplitRequests: setPnLEditSplitRequests, summaryParamters: summaryParamters })))) : (React.createElement(React.Fragment, null,
                React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: closeDrawerInitConfirm, isVisible: initConfirmBackDrop, className: "confirmationpopupmob" },
                    React.createElement(ConfirmationPopupMob, { popupClass: "", description: `You are only allowed to edit the details once. 
                          Are you sure you want to continue?`, popTitle: "Confirm Editing", btnFirstTitle: "No, Go Back", btnSecTitle: "Yes, Confirm", goBackBtn: true, btnFirstCta: closeDrawerInitConfirm, btnSecCta: initConfirm })),
                React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: closeDrawerReviewForm, isVisible: reviewChangePopup, className: "confirmationpopupmob" },
                    React.createElement(ConfirmationPopupMob, { popupClass: "", description: `You are not allowed to edit the details more than once. 
                Are you sure you want to continue?`, popTitle: "Confirm transaction changes", btnFirstTitle: "Review Changes ", btnSecTitle: "Yes, Confirm", goBackBtn: false, btnFirstCta: reviewGoBack, btnSecCta: reviewConfirm })),
                React.createElement(Drawer, { duration: 250, hideScrollbars: true, onClose: closeDrawerTransaction, isVisible: transactionPopup, className: "edittransaction" },
                    React.createElement(EditTransactionPopupMob, { popupClass: "", noticeText: "You are not allowed to edit the details more than once.", popTitle: "Edit Transaction", show: transactionPopup, setShow: setTransactionPopup, goBackBtn: false, confirmBtnTitle: "Confirm", confirmBtnCta: editConfirmation, goBackCta: editGoBack, editableRecord: editableRecord, summaryParamters: summaryParamters, setPnLEditSplitRequests: setPnLEditSplitRequests })),
                React.createElement(Drawer, { isVisible: showLoader, onClose: closeDrawerLoader, duration: 250, hideScrollbars: true, className: "drawer__handle-wrapper" },
                    React.createElement(SmcasePopupLoaderMob, { Title: "Holdings", closeDrawer: closeDrawerLoader })),
                React.createElement(Drawer, { isVisible: downloadSuccess, onClose: closeDrawerDownloadS, duration: 250, hideScrollbars: true, className: "drawer__handle-wrapper" },
                    React.createElement(SmcasePopupSuccessMob, { Title: "Holdings", closeDrawer: closeDrawerDownloadS, operation: "", message: "Your request was successfully processed." +
                            "Updated price will reflect in the P&L on " +
                            moment(getDay(1)).format("DD-MM-yyyy") +
                            ".", pageName: "view transaction report", sendBack: true, goBack: goBack })),
                React.createElement(Drawer, { isVisible: downloadFail, onClose: closeDrawerFail, duration: 250, hideScrollbars: true, className: "drawer__handle-wrapper" },
                    React.createElement(SmcasePopupFailMob, { closeDrawer: closeDrawerFail, operation: "", pageName: "view transaction report", sendBack: true, goBack: goBack })))))));
};
export default PnlViewTransactionReport;
